import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  TextField,
  Typography,
  Paper,
  Button,
  StepContent,
  StepLabel,
  Step,
  Stepper,
} from '@material-ui/core';
import DynamicFields from './DynamicFields';


const styles = theme => ({
  root: {
    width: '90%',
  },
  button: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  actionsContainer: {
    marginBottom: theme.spacing.unit * 2,
  },
  resetContainer: {
    padding: theme.spacing.unit * 3,
  },
});

class MsStepper extends React.Component {

  static propTypes = {

    data: PropTypes.data,
    dynamic: PropTypes.bool,

  };

  static defaultProps = {

    dynamic: false,
    answers: false,

  };

  constructor(props) {

    super(props);

    this.state = {
      activeStep: 0,
      lstExecution: {},
      wfsteps: {},
    };

  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.data.lstExecution && nextProps.data.lstExecution.length > 0)
      this.setState({ activeStep: nextProps.data.lstExecution.length });

  }

  shouldRender = () =>
  //   this.props.data.lstExecution
  //  && this.props.data.lstExecution.length > 0 &&
    this.props.data.wfsteps
   && this.props.data.wfsteps.length > 0


  handleNext = () => {

    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));

  };

  handleBack = () => {

    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));

  };

  handleReset = () => {

    this.setState({
      activeStep: 0,
    });

  };
  
  shouldRenderAnswers(index) {

    const { data } = this.props;
    let Answer = [];

    if(data.lstExecution[index] && data.lstExecution[index].formResult !== ''){
      Answer = JSON.parse(data.lstExecution[index].formResult);
    }

    return(
      Answer.length > 0 && <StepContent>
        {Answer.map(ans => (
          <Typography>
          {ans.FieldName}:{ans.Answer}
          </Typography>
        ))}
      </StepContent>
    )
  };


  render() {

    const { classes, data, onClick, onChange, dynamic, onClose, answers } = this.props;
    const { activeStep } = this.state;

    return (
      this.shouldRender() && <div className={classes.root}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {data.wfsteps.map((step, index) => (
            <Step key={index}>
              <StepLabel>{step.name}</StepLabel>
              {answers && this.shouldRenderAnswers(index)}
              {dynamic && data.wfsteps[index].form !== '' && <StepContent>
                <Typography>
                  <DynamicFields
                    data={data.wfsteps[index]}
                    onChange={onChange}
                    onClose={onClose}
                  />
                </Typography>
                <div className={classes.actionsContainer}>
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={onClick}
                      className={classes.button}
                    >
                     Check
                    </Button>
                  </div>
                </div>
              </StepContent>}
            </Step>
          ))}
        </Stepper>
        {activeStep === data.wfsteps.length && (
          <Paper square elevation={0} className={classes.resetContainer}>
            <Typography>Nota Finalizada !</Typography>
          </Paper>
        )}
      </div>
    );

  }
}

MsStepper.propTypes = {
  classes: PropTypes.style,
};

export default withStyles(styles)(MsStepper);



// WEBPACK FOOTER //
// ./src/components/tracker/Check/MsStepper.js